import {Component, HostListener, ViewChild, ElementRef, Input, OnInit} from '@angular/core';
import {ApiService} from '../services/api.service';
import {InternalService} from '../services/internal.service';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: "my-slider",
  templateUrl: "./silder.component.html",
  styleUrls: ["./silder.component.css"]
})
export class SliderComponent implements OnInit {
  constructor(
    public apiService: ApiService,
    private router: Router
  ) {}
  arr;
  @Input() set getListData(data: [any]) {
    this.arr = data;
  }
className:any ='mini-card';
   @Input() totalCards: number;
  @Input() size: number;
  currentPage: number = 1;
  pagePosition: string = "0%";
  cardsPerPage: number;
  totalPages: number;
  overflowWidth: string;
  cardWidth: string;
  containerWidth: number;
  @ViewChild('container', { static: true, read: ElementRef })
  container: ElementRef;
  @HostListener("window:resize") windowResize() {
    let newCardsPerPage = this.getCardsPerPage();
    if (newCardsPerPage != this.cardsPerPage) {
      this.cardsPerPage = newCardsPerPage;
      this.initializeSlider();
      if (this.currentPage > this.totalPages) {
        this.currentPage = this.totalPages;
        this.populatePagePosition();
      }
    }
  }

  ngOnInit() {
    this.cardsPerPage = this.getCardsPerPage();
    this.initializeSlider();

     // console.log(this.arr)


  }

  initializeSlider() {
    this.totalPages = Math.ceil(this.totalCards / this.cardsPerPage);
    this.overflowWidth = `calc(${this.totalPages * 100}% + ${this.totalPages *
    10}px)`;
    this.cardWidth = `calc((${100 / this.totalPages}% - ${this.cardsPerPage *
    10}px) / ${this.cardsPerPage})`;
  }

  getCardsPerPage() {
    return Math.floor(this.container.nativeElement.offsetWidth / this.size);
  }

  changePage(incrementor) {
    this.currentPage += incrementor;
    this.populatePagePosition();
  }

  populatePagePosition() {
    this.pagePosition = `calc(${-100 * (this.currentPage - 1)}% - ${10 *
    (this.currentPage - 1)}px)`;
  }
  loadData(id){
    // localStorage.setItem('isLeaf', 'true');
    this.router.navigate(['service-description/' + id ]);
  }
}
